import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../ActionTypes";
import {
  saveTeamCoverImageSuccess,
  saveTeamCoverImageFailure,
  updateTeamCoverImageSuccess,
  updateTeamCoverImageFailure,
  deleteTeamCoverImageSuccess,
  deleteTeamCoverImageFailure,
} from "./teamCoverImageActions";
import {
  saveTeamCoverImageApi,
  updateTeamCoverImageApi,
  deleteTeamCoverImageApi
} from "./teamCoverImage";

// 🔹 SAVE TEAM COVER IMAGE
function* saveTeamCoverImageSaga(action) {
  const { apiPayloadRequest, callback } = action.payload || {};

  try {
    const data = yield call(saveTeamCoverImageApi, apiPayloadRequest);

    // Ensure callback always runs
    if (String(data?.type) === "1" || data?.type === 1) {
      yield put(saveTeamCoverImageSuccess(data.data || apiPayloadRequest));

      if (callback) callback({ type: 1, data });
    } else {
      yield put(saveTeamCoverImageFailure(data?.error || "Save failed"));
            if (callback) callback({ type: 0, error: data?.error || "Save failed" });
    }
  } catch (error) {
    yield put(saveTeamCoverImageFailure(error.message));
        if (callback) callback({ type: 0, error: error.message });
  }
}



// 🔹 UPDATE TEAM COVER IMAGE
function* updateTeamCoverImageSaga(action) {
  try {
    const { apiPayloadRequest, callback } = action.payload || {}; // ✅ destructure here
    const data = yield call(updateTeamCoverImageApi, apiPayloadRequest);

    if (data?.type === 1) {
      yield put(updateTeamCoverImageSuccess(data.data || apiPayloadRequest));
      if (callback) callback({ type: 1, data: data.data });
    } else {
      yield put(updateTeamCoverImageFailure(data?.error || "Update failed"));
      if (callback) callback({ type: 0, error: data?.error });
    }
  } catch (error) {
    yield put(updateTeamCoverImageFailure(error.message));
    if (action.payload?.callback) action.payload.callback({ type: 0, error: error.message });
  }
}
function* deleteTeamCoverImageSaga(action) {
  try {
    const { apiPayloadRequest, callback } = action.payload || {};
    const data = yield call(deleteTeamCoverImageApi, apiPayloadRequest);

    if (data?.type === 1) {
      yield put(deleteTeamCoverImageSuccess(apiPayloadRequest));
      if (callback) callback({ type: 1, data });
    } else {
      yield put(deleteTeamCoverImageFailure(data?.error || "Delete failed"));
      if (callback) callback({ type: 0, error: data?.error });
    }
  } catch (error) {
    yield put(deleteTeamCoverImageFailure(error.message));
    if (action.payload?.callback) action.payload.callback({ type: 0, error: error.message });
  }
}
// 🔹 WATCHER
export default function* teamCoverImageWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_TEAM_COVERIMAGE_REQUEST, saveTeamCoverImageSaga);
  yield takeLatest(actionTypes.UPDATE_TEAM_COVERIMAGE_REQUEST, updateTeamCoverImageSaga);
  yield takeLatest(actionTypes.DELETE_TEAM_COVERIMAGE_REQUEST, deleteTeamCoverImageSaga);

}
